// extracted by mini-css-extract-plugin
export default {"container":"OSBranding_container__+YqZh","img":"OSBranding_img__A503m"};